import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports :[ReactiveFormsModule, NgxMatTimepickerModule ],
})
export class TimeInputComponent extends BaseInputDirective implements OnInit {

  
 



  ngOnInit() {
    super.ngOnInit();
  }
}
